import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  .content-vazio {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .item-vazio {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 2em;

      .title {
        margin-left: 1em;
        width: 14em;

        p {
          color: ${Colors.ft_color_11};
          font-size: 1em;
        }
      }
    }
  }
`;

export const ThisCard = styled.div`
  margin-bottom: 1.3em;
  width: 100%;
  display: flex;
  flex-direction: column;

  .card-top {
    padding: 0.6em;
    border-radius: 0.5em;
    background: ${Colors.Color1};
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card-top-left {
      display: flex;
      margin-left: 0.5em;
      align-items: center;

      .titulo {
        font-size: 0.85em;
        width: 100%;
        font-weight: 800;
        color: ${Colors.Color4};
        margin-left: 0.75em;
      }
      .iCliente {
        height: 1.8em;
        width: 1.8em;
      }
    }

    .card-top-right {
      border-radius: 0.4em;
      width: 1.7em;
      height: 1.7em;
      padding: 0.5em;
      background: #212121;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const ThisCardAnal = styled.div`
  margin-top: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .card-a-top {
    padding: 0.5em;
    width: 98%;
    border-radius: 0.5em;
    background: ${Colors.Color1};
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5em;

    .card-a-top-left {
      display: flex;
      margin-left: 0.5em;

      .iAnalista {
        height: 1.8em;
        width: 1.8em;
      }
      
      .titulo-a {
        font-size: 0.85em;
        width: 100%;
        font-weight: 800;
        color: ${Colors.Color4};
        margin-left: 0.75em;
        display: flex;
        align-items: center;
      }
    }

    .card-a-top-right {
      border-radius: 0.4em;
      width: 1.7em;
      height: 1.7em;
      padding: 0.35em;
      background: #212121;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
      }
    }
  }

  .card-a-list {
    display: flex;
    flex-direction: column;
    margin-left: 0.5em;
    justify-content: space-between;
    width: 100%;

    .list-a {
      display: flex;
      justify-content: space-around;

      .list-a-itens {
        .titulo-a-list {
          font-size: 0.8em;
          width: 100%;
          font-weight: 800;
          color: ${Colors.Color4};
          margin-left: 1.5em;
          margin-bottom: 1em;
        }

        .subtitulo-a-list {
          font-size: 0.75em;
          width: 100%;
          font-weight: 600;
          color: #8f9daf;
          margin-bottom: 0.5em;
          margin-left: 1.5em;
        }
      }
    }
  }
`;
